import { create }       from 'zustand';
import { persist }      from 'zustand/middleware';
import type { Role }    from '@/constants/roles';

// ── Types ────────────────────────────────────────────────────
export interface AuthUser {
  userId:    string;
  email:     string;
  name:      string;
  role:      Role;
  avatarUrl: string | null;
}

interface AuthState {
  token:   string | null;
  user:    AuthUser | null;

  // Actions
  setAuth:  (token: string, user: AuthUser) => void;
  setUser:  (user: Partial<AuthUser>) => void;
  logout:   () => void;
  isRole:   (role: Role | Role[]) => boolean;
}

// ── Store ────────────────────────────────────────────────────
export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user:  null,

      setAuth: (token, user) => set({ token, user }),

      setUser: (partial) =>
        set((s) => ({
          user: s.user ? { ...s.user, ...partial } : null,
        })),

      logout: () => set({ token: null, user: null }),

      isRole: (role) => {
        const current = get().user?.role;
        if (!current) return false;
        return Array.isArray(role)
          ? role.includes(current)
          : current === role;
      },
    }),
    {
      name:    'architect-erp-auth',
      // Only persist token + user — not the action functions
      partialize: (s) => ({ token: s.token, user: s.user }),
    },
  ),
);